import { render, staticRenderFns } from "./AppendixCompass.vue?vue&type=template&id=af1430ac&"
import script from "./AppendixCompass.vue?vue&type=script&lang=ts&"
export * from "./AppendixCompass.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports